import { render, staticRenderFns } from "./ReposDraft.vue?vue&type=template&id=7c4e73b8&"
import script from "./ReposDraft.vue?vue&type=script&lang=js&"
export * from "./ReposDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports